module.exports = "<ul class=\"CheckboxList\">\n  <li>\n    <label class=\"checkBox\" ng-class=\"{disabled: $ctrl.content.isLocked}\">\n      <input type=\"checkbox\" ng-model=\"$ctrl.content.isInstalled\"\n        ng-disabled=\"$ctrl.content.isLocked\"\n        ng-click=\"$ctrl.displayAlert($ctrl.checked)\">\n      <span>{{$ctrl.content.title}} {{$ctrl.size}}</span>\n    </label>\n  </li>\n</ul>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/vehicle/manage-my-rlink/components/device-content/device-content.html
// module id = 1214
// module chunks = 0